
import React from 'react';

const FormErrors = ({ formErrors }) =>
  (
    <div className="form-errors">
      {Object.keys(formErrors).map((fieldName, i) => {
        if (formErrors[fieldName].length > 0) {
            // eslint-disable-next-line
            return (<span key={i}>{formErrors[fieldName]}</span>);
        }

        return '';
        })
      }
    </div>
  );

export default FormErrors;



// WEBPACK FOOTER //
// ./src/Components/FormErrors.js